/* eslint-disable eqeqeq */
import {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
  useRef,
} from "react";
import { StockAdjustmentRo, vRdxUserInfo } from "../../Redux/roStore";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { RoundingDigitRo } from "../../Redux/roStore";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Box from "@mui/material/Box";
import GCStockTransfer from "../../Component/Common/ReuseableComponent/GCStockTransfer";

import {
  fAlertToast,
  fcovertToNumber,
  fKeyTabInput,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";
import {
  inv11_Approve_INV11_GETROW,
  inv11_INV11_Delete_GETROW,
  inv11_INV11_Search_GETROW,
  inv11_ReverseINV11_GETROW,
  inv11_save_INV11_GETROW,
  inv11_validationINV11_GETROW,
  SubKonten_Search_Full_V3Api,
} from "../../Server/ApiV2";
import { fFocusInput } from "../../Utility/Utilitys";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCHead from "./processComponent/GCHead";
import WmsFooter from "./processComponent/WmsFooter";
import {
  Set_StockAdjustment_HeadObject_Set,
  Set_StockAdjustment_HeadObject_Init,
  StockAdjustment_HeadObject_New_Set,
  Set_StockAdjustment_HeadObject_A_DocStat,
  Set_StockAdjustment_HeadObject_A_VocNo,
} from "./SliceStockAdjustment";
import "./StockAdjustment.css";
import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  fRightClick,
  fLeftClick,
  sTax,
  sTrnTyp,
  sStatusArr,
  fKeyStockAdjustment,
  fKeyStockAdjustmentContent,
  GetUnitArr,
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fDisplay,
  fStockAdjustmentCal,

  //Head
  GetAttributes,
  getTransItemStockUOM,
  GetHeadGrid,
  Get_GCToggleSearch_Customer_Api,
  GetUnitRateArr,
  fCalUCostAndValue,
  Unit_Onchange_001,
} from "./StockAdjustmentAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { fCheck_Doc_Rights_001 } from "../../Utility/Utilitys";
import {
  FShortCutKey,
  GetAccountPostingDetail,
  GetLinkDocument,
} from "../../Utility/Utilitys";
import GCAccountDetail from "../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import PoNoSearchModal from "./processComponent/PoNoSearchModal";
import POTypeSearchModal from "./processComponent/POTypeSearchModal";
import BatchSelectionModal from "./processComponent/BatchSelectionModal";
import BatchSelectionModalIssue from "./processComponent/BatchSelectionModalIssue";
import ReqDocumentSearchModal from "./processComponent/ReqDocumentSearchModal";
import GCLocationWiseStock from "./processComponent/LocationWiseStock";
import GCContent from "./processComponent/GCContent";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function StockAdjustmentNormal() {
  const dispatch = useDispatch();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const { roundingDigit } = RoundingDigitRo();
  const vMediaQuery = useMediaQuery("(max-width:750px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceStockAdjustment.value.HeadObject
  );

  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value

  const [sRoundingVal, setRoundingVal] = useState(roundingDigit);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [sLoading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sArr, setArr] = useState([]);

  //HEAD
  const [sDocLoading, setDocLoading] = useState([]);
  const [sAdjustmentType, setAdjustmentType] = useState([]);
  const [sFromLocation, setFromLocation] = useState([]);

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sFooterObj, setFooterObj] = useState({
    F_NetValue: (0).toFixed(sRoundingVal),
  });
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });

  //head grid
  const [sHeadGridRow, setHeadGridRow] = useState([]);
  const [sHeadGridColumn, setHeadGridColumn] = useState([
    { field: "Location", headerName: "Location", width: 110 },
    { field: "StkQty", headerName: "Stk", width: 50 },
    { field: "PRQty", headerName: "PR", width: 50 },
    { field: "SOQty", headerName: "SO", width: 50 },
    { field: "DOQty", headerName: "DO", width: 50 },
    { field: "SIQty", headerName: "INV", width: 50 },
    { field: "TRFQty", headerName: "TRF", width: 50 },
    { field: "ADJQty", headerName: "ADJ", width: 50 },
    { field: "Reserved", headerName: "Rsvd", width: 50 },
    { field: "AvlQty", headerName: "Avl", width: 50 },
    { field: "id", headerName: "id", hide: true },
  ]);
  const [headGridShow, setHeadGridShow] = useState(false);

  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select
  const [isSaveLoaded, setSaveLoaded] = useState(false);

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    Narration: "",
    B_UnitCost: 0,
    B_Value: 0,
    Reason: "",
    Auto: "N",
  };
  const [sReason, setReason] = useState([]);
  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  //LocationwiseStock start
  const [sLocationwiseStockModal, setLocationwiseStockModal] = useState(false);
  //LocationwiseStock end
  //Modal

  const [poType, setPoType] = useState(false);
  const [poNo, setPoNo] = useState(false);
  const [sReqDocumentSearchModal, setReqDocumentSearchModal] = useState(false);

  // Batch start
  const [SerialDetalModal, setSerialDetalModal] = useState({
    SrNo: 0,
    ItemCd: "",
    Batch: "N",
    Serial: "N",
    AutoGrn: "N",
  });
  const [sbatchSelectionModalEntry, setBatchSelectionModalEntry] =
    useState(false);
  const [sbatchSelectionModal, setBatchSelectionModal] = useState(false);

  // Batch end
  //Reverse

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      trnTyp: sTrnTyp,
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_DocStat: vRdxWmsHead.A_DocStat,
      v_UserCd: vRdxuserInfo.UserID,
      v_IP: vRdxuserInfo.IP,
    };
    const vRevereTransaction = await inv11_ReverseINV11_GETROW(
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_StockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_StockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_StockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_StockAdjustment_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     A_PostDt: event.$d,
    //   })
    // );
  };

  const fInvDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_StockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_StockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: event?.$d,
        })
      );
    }

    // dispatch(
    //   Set_StockAdjustment_HeadObject_Set({ ...vRdxWmsHead, A_RefDt: event.$d })
    // );
  };

  const fFromLocation = async (e) => {
    let vFromLoaction = sFromLocation.find((obj) => {
      return obj.UId === e.target.value;
    });
    if (!!vFromLoaction) {
      dispatch(
        Set_StockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_FromLocBr: vFromLoaction.Br,
          A_FromLocBatch:
            vFromLoaction.BatchCtrl == "Y" ? "Batch : Yes" : "Batch : No",
          A_FromLoc: vFromLoaction.UId,
        })
      );
    }
  };

  //FOOTER FUNCTION

  const fHeadNarration = (e) => {
    dispatch(
      Set_StockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_Narr: e.target.value,
      })
    );
  };
  //DETAIL FUNCTIOn
  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
    if (e.target.name == "B_Qty") {
      GetHeadGrid(setHeadGridRow, setHeadGridShow, sBufferObj.B_Itmcd);
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(sRoundingVal),
      }));
    }
    if (e.target.name == "B_Qty") {
      setHeadGridShow(false);
    }
  };

  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });

    await Unit_Onchange_001(
      vUnitvalue,
      sBufferObj.B_Itmcd,
      setBufferObj,
      sBufferObj,
      vRdxWmsHead
    );
  };

  const fQty_Save_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER" &&
        !isSaveLoaded
      ) {
        setSaveLoaded(true);
        document.getElementsByName("B_Qty")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };
  const fNarration = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e.target.value,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
    let {
      B_BaseQty, //Decimal
    } = fStockAdjustmentCal(e.target.value, sBufferObj.B_PackQty);
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
    }));

    fCalUCostAndValue(e.target.value, sBufferObj.B_UnitCost, setBufferObj);
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_FromLoc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_FromLoc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    setLoading(true);

    if (e.key === "Enter" || e._reactName === "onClick") {
      if (
        vRdxWmsHead.A_FromLoc === "" ||
        vRdxWmsHead.A_FromLoc === null ||
        vRdxWmsHead.A_FromLoc === undefined
      ) {
        setErrorMsg((obj) => ({
          ...obj,
          A_FromLoc: "Location should not be Empty",
        }));
      }

      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_FromLoc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(
          vItemSearchFull,
          vRdxWmsHead,
          sBufferObj,
          setBufferObj,
          setUnit
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: 0,
        B_BaseQty: 0,
        B_UnitCost: 0,
        B_Value: 0,
      }));

      setUnit([]);
    }
  };

  //MODAL HEAD

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_FromLoc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(
        vItemSearchFull,
        vRdxWmsHead,
        sBufferObj,
        setBufferObj,
        setUnit
      );
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //MODAL SEARCH

  const [sLocationArr, setLocationArr] = useState([{ UId: "", Name: "" }]);
  const [sLocationSearchArr, setLocationSearchArr] = useState([
    { UId: "", Name: "" },
  ]);
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: new Date(),
    Loc: "All",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    document.getElementById("IdSearch")?.blur();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: "All",
    }));
    GetSearchValue("", "APICallLocModal", "All");
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: new Date(),
      Loc: sLocationArr[0].UId,
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail);
    fCloseSearchModal();
  };

  //GCSearch
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
      fDisplay(
        newSelectionModel?.row?.A_VocTyp,
        newSelectionModel?.row?.A_VocNo,
        dispatch,
        fNewDetail
      );
      fCloseSearchModal();
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: moment(event.target.value, "YYYY-MM-DD")._d,
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // GetSearchValue("", "APICALLDATE", changedDate);
  };

  const fonChangeLocModal = (event, selectArr) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: event.target.value,
    }));
    GetSearchValue("", "APICallLocModal", event.target.value);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let vSearchObj = {
        // VocDt:
        //   xAPICALL === "APICALLDATE"
        //     ? moment(xSTATUS).format("MM/DD/YYYY")
        //     : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY"),

        v_TrnTyp: sTrnTyp,
        v_VocNo: sSearchModalObj.VocNo,
        v_PostDt: "01/01/1900",
        v_Loc:
          xAPICALL === "APICallLocModal"
            ? xSTATUS == "All"
              ? ""
              : xSTATUS
            : sSearchModalObj.Loc == "All"
            ? ""
            : sSearchModalObj.Loc,
        v_Status:
          xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        v_UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const resp = await inv11_INV11_Search_GETROW(FinalObj);
      if (resp?.status === 200) {
        let vSearchArr = resp?.data?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      }
    }
  };

  //MODAL SEARCH END

  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = StockAdjustmentRo();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end
  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = StockAdjustmentRo();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //document
  const [sDocumentModal, setDocumentModal] = useState(false);
  const fDocument = () => {
    fOpenDocumentModal();
  };
  const fOpenDocumentModal = () => {
    setDocumentModal(true);
  };
  const fCloseDocumentModal = (e) => {
    setDocumentModal(false);
  };

  //GCLandedCost

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vTransAuditObj);
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", FinalObj);
    if (vTransAudit?.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };

  //API DETAIL

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].A_VocTyp,
      sUser_Doc_Arr[0].A_VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1]?.A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1]?.A_VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1]?.A_VocTyp,
        sUser_Doc_Arr[row - 1]?.A_VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1]?.A_VocTyp,
        sUser_Doc_Arr[row - 1]?.A_VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;
      // /WMS/StkAdjustment?&prntyp=INV11&VocTyp=AD001&VocNo=EADJ000001&TrnTyp=INV11

      let urlPrint =
        webReport?.Val +
        "/WMS/StkAdjustment?TrnTyp=" +
        sTrnTyp +
        "&VocTyp=" +
        vRdxWmsHead.A_VocTyp +
        "&VocNo=" +
        vRdxWmsHead.A_VocNo +
        "&prntyp=" +
        xPrnTyp;
      console.log(urlPrint);
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );
  const [registerSerialNumberModal, setRegisterSerialNumberModal] =
    useState(false);
  const [batchFlag, setbatchFlag] = useState(false);

  const [sBatchObj, setBatchObj] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    Qty: 0,
    Unit: "",
    BaseQty: 0,
  });
  const Save = async (xSave, xDocStatus = vRdxWmsHead.A_DocStat) => {
    const vRdxUserInfoObj = vRdxUserInfo();

    const { HeadObject } = StockAdjustmentRo();
    let iBr =
      sLocationArr.length > 0
        ? sLocationArr.find((item) => item.UId == HeadObject.A_FromLoc)
        : {};
    const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post
    let vSaveSIHeadObj = {
      A_VocTyp: HeadObject.A_VocTyp,
      A_VocNo: HeadObject.A_VocNo,
      A_VocDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
      A_PostDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
      A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
      A_RefNo: "",
      A_Type: "",
      A_Br: iBr?.Br || "",
      A_Loc: HeadObject.A_FromLoc,
      A_RefBy: "",
      A_Narr: HeadObject.A_Narr,
      A_NetAmt: 0,
      A_DocStat: iStatus,
      v_IP: vRdxUserInfoObj.IP,
      v_UserId: vRdxUserInfoObj.UserID,
      A_RefNo1: "",
      A_RefNo2: "",
      A_RefNo3: "",
      A_RefNo4: 0,
      A_RefNo5: 0,
      A_RefNo6: 0,
      A_CUSTFIELD8: HeadObject.A_FromLocBatch,
      A_CUSTFIELD9: HeadObject.A_Do,

      // Detail fields
      v_B_Srno: sBufferObj.B_Srno,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: parseFloat(sBufferObj.B_Qty),
      v_B_Unit: sBufferObj.B_Unit,
      v_B_BaseQty: 0,

      v_B_Auto: sBufferObj.Auto,
      v_B_UCost: parseFloat(sBufferObj.B_UnitCost),
      v_B_NetAmt: parseFloat(sBufferObj.B_Value),
      v_B_RSP: 0,
      v_B_Type: sBufferObj.Reason,
      v_ErrorMsg: "",
      A_StkAdjTyp: HeadObject.AdjustmentType,
      A_StkAdjPrdCd: "",
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

    const vSaveSIHead = await inv11_save_INV11_GETROW(FinalObj);
    if (vSaveSIHead?.status === 200) {
      let iVocNo = xSave
        ? vSaveSIHead?.data?.ResultSet?.DocNo
        : vRdxWmsHead.A_VocNo;
      if (HeadObject?.A_VocNo == "0") {
        setUser_Doc_Arr([
          ...sUser_Doc_Arr,
          {
            A_VocTyp: HeadObject.A_VocTyp,
            A_VocNo: iVocNo,
            SrNo: sUser_Doc_Arr.length + 1,
          },
        ]);
      }

      dispatch(
        Set_StockAdjustment_HeadObject_A_VocNo({
          A_VocNo: iVocNo,
          A_DocStat: iStatus,
        })
      );

      //approve bool type false
      if (!xSave) {
        fDisplay(HeadObject.A_VocTyp, iVocNo, dispatch, fNewDetail);
        // setTimeout(() => {
        //   GetCostUpdate(sTrnTyp, HeadObject?.A_VocTyp, HeadObject?.A_VocNo);
        // }, 200);
        fAlertToast("SUCCESS", "Successfully posted");
      } else {
        console.log(vSaveSIHead?.data?.ResultSet);
        let obj = {
          ...vSaveSIHead?.data?.ResultSet?.Detail[0], // Merging the existing object
          ItemCd: sBufferObj.B_Itmcd, // Adding new field itmcd,
          // ItemCd:101421,// Adding new field itmcd,
          // SrNo:1// Adding new field itmcd,
        };
        setSerialDetalModal(obj);
        let { Batch, Serial, AutoGrn, SrNo, Type } =
          vSaveSIHead?.data?.ResultSet.Detail[0];
        if (Batch == "Y" || Serial == "Y") {
          setBatchObj((obj) => ({
            ...obj,
            SrNo: SrNo,
            ItemCode: sBufferObj.B_Itmcd,
            ItemName: sBufferObj.B_ItmName,
            Qty: sBufferObj.B_Qty,
            Unit: sBufferObj.B_UnitName,
            BaseQty: sBufferObj.B_BaseQty,
          }));
          if (Type == "BATCH_ENTRY") {
            setBatchSelectionModalEntry(true);
          } else if (Type == "BATCH_ISSUE") {
            setBatchSelectionModal(true);
          }
        }
        if (AutoGrn == "Y") {
          setRegisterSerialNumberModal(true);
        }
        fNewDetail(iVocNo, HeadObject?.A_VocTyp);
        fAlertToast("SUCCESS", "Successfully Saved");
      }
    }
  };
  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        await handleSaveOrApprove(xsave, docstatus);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };

  const validationServerSide = async () => {
    const { HeadObject } = StockAdjustmentRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let iBr =
      sLocationArr.length > 0
        ? sLocationArr.find((item) => item.UId == HeadObject.A_FromLoc)
        : {};
    let obj = {
      v_UserId: vRdxUserInfoObj.UserID,
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_FromLoc,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: sBufferObj.B_Qty,
      v_Br: iBr?.Br || "",

      SrNo: sBufferObj.B_Srno,
      Unit: sBufferObj.B_Unit,
      NumerFormat: "",
      v_B_Auto: sBufferObj.Auto,
      v_A_StkAdjTyp: HeadObject.AdjustmentType,
    };
    let resp = await inv11_validationINV11_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg || "error in validationWMINV03 "
        );
        const errorField = resp?.response?.data?.message?.field;
        const errorMsg = resp?.response?.data?.message?.msg;
        if (ErrorMsg.hasOwnProperty(errorField)) {
          setErrorMsg((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        } else if (ErrorMsgDetail.hasOwnProperty(errorField)) {
          setErrorMsgDetail((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };

  const [sCurrentStock, setCurrentStock] = useState({
    A_CurrentStockQty: 0,
    A_CurrentStockValue: 0,
  });
  const GetCurrentStock = async (
    Loc = vRdxWmsHead.A_FromLoc,
    ItmCd = sBufferObj.B_Itmcd,
    Date = vRdxWmsHead.A_RefDt,
    setCurrentStock
  ) => {
    let vItemStockObj = {
      Loc: Loc,
      ItmCd: ItmCd,
      Date: moment(Date).format("MM/DD/YYYY"),
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vItemStockObj);

    const vItemStock = await fExecuteAPI(
      "WMINV11_currentStock_GETROW",
      FinalObj
    );

    if (vItemStock?.Type?.toUpperCase() === "SUCCESS") {
      let result = vItemStock?.ResultSet[0] || {};
      if (vItemStock.ResultSet.length > 0) {
        setCurrentStock((obj) => ({
          ...obj,
          A_CurrentStockQty: result?.StockQty || 0,
          A_CurrentStockValue: result?.StockValue || 0,
        }));
      } else {
        setCurrentStock((obj) => ({
          ...obj,
          A_CurrentStockQty: 0,
          A_CurrentStockValue: 0,
        }));
      }
    } else {
      fAlertToast("FAILED", vItemStock?.response?.data?.message);
    }
  };

  useEffect(() => {
    let iDate = moment(vRdxWmsHead.A_RefDt).format("MM/DD/YYYY");
    if (
      vRdxWmsHead.A_DocStat === "POST" ||
      vRdxWmsHead.A_RefDt == "" ||
      vRdxWmsHead.A_RefDt == null ||
      vRdxWmsHead.A_RefDt === undefined ||
      vRdxWmsHead.A_RefDt == "Invalid Date" ||
      new Date(iDate) < new Date("01/01/1990")
    ) {
      return;
    } else {
      GetCurrentStock(
        vRdxWmsHead.A_Loc,
        sBufferObj.B_Itmcd,
        vRdxWmsHead.A_RefDt,
        setCurrentStock
      );
    }
  }, [
    vRdxWmsHead.A_Loc,
    sBufferObj.B_Itmcd,
    vRdxWmsHead.A_RefDt,
    vRdxWmsHead.A_DocStat,
  ]);
  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    if (vRdxWmsHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await Save(xsave, docstatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await Save(xsave, docstatus);
    }
  };

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      setSaveLoaded(false);

      if (vRdxWmsHead.A_DocStat == "POST" || vRdxWmsHead.A_DocStat == "DRAFT") {
        confirmAlert({
          title: "Reverse",
          message: `Are you sure to Reverse.`,
          buttons: [
            {
              className: "alertBtn",
              label: "Yes",
              onClick: async () => {
                let resp = await GetRevereTransaction();
                if (resp?.status === 200) {
                  fClearErrorMsg();
                  dispatch(
                    Set_StockAdjustment_HeadObject_A_DocStat({
                      A_DocStat: "ENTER",
                    })
                  );
                  fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
                }
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {},
            },
          ],
        });
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(
          vRdxWmsHead,
          setErrorMsg,
          sFooterObj
        );

        if (!validation) return;

        let validationDetil = fValidationDetail_Client(
          vRdxWmsHead,
          sBufferObj,
          setErrorMsgDetail,
          sDetailGridData
        );

        if (!validationDetil) return;

        // let server_Validation =true
        let server_Validation = await validationServerSide();
        if (!server_Validation) return;

        if (server_Validation) {
          await handleSaveOrApprove(true);
        }
      }
    }, 500);
  };

  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = StockAdjustmentRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let obj = {
      //approve cnfimartion:HeadObject.qqqqq,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_RefDt).format("MM-DD-YYYY"),
      v_Loc: HeadObject.A_FromLoc,
      v_UserCd: vRdxUserInfoObj.UserID,
    };
    let resp = await inv11_Approve_INV11_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg || "error in Validate   "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (ErrorMsg.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else if (ErrorMsgDetail.hasOwnProperty(errorField)) {
            setErrorMsgDetail((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg || "error in validationWMINV03 "
            );
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };
  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }

      let validation = fValidationHead_Client(
        vRdxWmsHead,
        setErrorMsg,
        sFooterObj
      );

      if (!validation) return;

      let Searver_ValidationApprove = await ValidationApprove(
        false,
        xDocStatus
      );
      if (!Searver_ValidationApprove) return;

      if (!!Searver_ValidationApprove) {
        setTimeout(() => {
          confirmAlert({
            title: "Approve",
            message: "Are you want to Approve..",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: async () => {
                  await Save(false, xDocStatus);
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {
                  return;
                },
              },
            ],
          });
        }, 200);
      }
    }, 800);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      fNewHead();
      fNewDetail(0, sDocLoading[0]?.VocTyp);
      document.getElementsByName("A_PostDt")[0]?.focus();
    } else {
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fNewHead = async () => {
    dispatch(Set_StockAdjustment_HeadObject_Init()); // Head Clearing

    let { Br, UId, BatchCtrl } = sFromLocation[0];

    // Setting Initial List Box 0th Object
    dispatch(
      StockAdjustment_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_FromLocBr: Br || "",
        A_FromLocBatch:
          !!BatchCtrl && BatchCtrl == "Y" ? "Batch : Yes" : "Batch : No",
        A_FromLoc: UId,
        AdjustmentType: sAdjustmentType[0]?.UId,
      })
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      F_NetValue: (0).toFixed(sRoundingVal),
    }));

    // document.getElementsByName("A_RefDocNo")[0]?.focus();
  };

  const fNewDetail = (xVocNo, xVocTyp) => {
    setBufferObj(vBufferObjInit);
    setBufferObj((obj) => ({
      ...obj,
      Auto: sBufferObj.Auto,
    }));
    setUnit([]);

    fLoad_Grid(
      xVocNo,
      0,
      setDetailGridData,
      setFooterObj,
      xVocTyp,
      sRoundingVal
    );

    document.getElementsByName("B_ItmName")[0]?.focus();
  };
  const fDeleteAPi = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIHeadObj = {
      v_TrnTyp: sTrnTyp,
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_IP: vRdxuserInfo.IP,
      v_UserId: vRdxuserInfo.UserID,
      v_Srno: Srno,
      v_ErrorMsg: "",
      AdjTyp: vRdxWmsHead.AdjustmentType,
    };

    const resp = await inv11_INV11_Delete_GETROW(vDeleteSIHeadObj);

    if (resp?.status === 200) {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Set_StockAdjustment_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_VocNo,
          dispatch,
          fNewDetail
        );
        // fNewDetail(
        //   vRdxWmsHead.A_VocNo,
        //   vRdxWmsHead.A_VocTyp,
        // );
        fAlertToast("SUCCESS", "Successfully Deleted");
      } else {
        fAlertToast("SUCCESS", "Successfully Deleted Line Item");
        fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
      }
    }
  };
  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteAPi(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteAPi(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  //GCToggleSearch_Customer start

  //Customer Search
  const [columnsCustomerDropdownSearch, setcolumnsCustomerDropdownSearch] =
    useState([
      {
        field: "id",
        headerName: "ID",
        hide: true,
        width: 70,
        align: "center",
        headerAlign: "center",
        Typ: "S",
        NumberFormat: "0",
      },
      {
        field: "AcCd",
        headerName: "Code",
        hide: false,
        width: 72,
        align: "left",
        headerAlign: "left",
        Typ: "S",
        NumberFormat: "0",
      },
      {
        field: "Name2",
        headerName: "Name2",
        hide: false,
        width: 450,
        align: "left",
        headerAlign: "left",
        Typ: "S",
        NumberFormat: "0",
      },
      {
        field: "Name1",
        headerName: "Name1",
        hide: false,
        width: 450,
        align: "left",
        headerAlign: "left",
        Typ: "S",
        NumberFormat: "0",
      },
    ]);
  const [
    GCToggleSearch_Customer_Row_GridData,
    set_GCToggleSearch_Customer_Row_GridData,
  ] = useState([]); //for ARR FOR CUSTOMER SEARCH

  const [
    GCToggleSearch_Customer_ModelObj,
    set_GCToggleSearch_Customer_ModelObj,
  ] = useState({
    AnyData: "",
    Name: "",
    Code: "",
  });

  const fClearSimpleSearch = () => {
    set_GCToggleSearch_Customer_ModelObj({
      ...GCToggleSearch_Customer_ModelObj,
      AnyData: "",
      Name: "",
      Code: "",
    });
  };

  const [
    GCToggleSearch_Customer_CloseModal,
    set_GCToggleSearch_Customer_Close_Modal,
  ] = useState(false);
  // const GCToggleSearch_Customer_Open_Modal = () => {
  //   set_GCToggleSearch_Customer_Close_Modal(true);
  // };
  const GCToggleSearch_Customer_fCloseModal = (e) => {
    set_GCToggleSearch_Customer_Close_Modal(false);
    fClearSimpleSearch();

    set_GCToggleSearch_Customer_ModelObj({
      AnyData: "",
      Name: "",
      Code: "",
    });
  };
  const GetTransTaxType = async (xLoc, xParty) => {
    let vTransTaxTypeObj = {
      loc: xLoc,
      party: xParty,
      taxtype: "OUT",
    };
    const vItemStock = await fExecuteAPI(
      "TransTaxType_GETROW",
      vTransTaxTypeObj
    );
    if (vItemStock?.Type?.toUpperCase() === "SUCCESS") {
      return vItemStock.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vItemStock.response.data.Status ||
          vItemStock?.response?.data?.message ||
          vItemStock?.message
      );
      return [];
    }
  };
  let vIsDownKeyPressedSimpleSearch = false;

  //defcustomersetting_GETROW
  const GetDefcustomersetting = async (xAcCd, xLoc) => {
    const vSONAS_INVOICE = vRdxDBKernObj.SONAS_INVOICE;
  };
  const GCToggleSearch_Customer_RowClick = async (e) => {
    // let iDefaultTaxType = await GetTransTaxType(
    //   vRdxWmsHead.A_Loc,
    //   e?.row?.AcCd
    // );
    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc,
      e?.row?.AcCd
    );
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    }
    //if inter.comp then tax group should be 0

    dispatch(
      Set_StockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        A_TaxType: vDefaultTaxType,
      })
    );

    if (!vIsDownKeyPressedSimpleSearch) {
      GetDefcustomersetting(e?.row?.AcCd, vRdxWmsHead.A_Loc);
      setTimeout(() => {
        document.getElementsByName("B_ItmName")[0]?.focus();
      }, 500);
      GCToggleSearch_Customer_fCloseModal();
      set_GCToggleSearch_Customer_Toggle(false);
    }
    vIsDownKeyPressedSimpleSearch = false;
  };

  const GCToggleSearch_Customer_RowCellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_Customer_RowClick(newSelectionModel);
    }
  };

  const GCToggleSearch_Customer_Enter_ModalKey = async (e, ModalName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vSupplierSearchDataObj = {
        Typ: "D",
        Data: vRdxWmsHead?.A_PartyName ?? "",
      };

      const vSupplierSearch = await SubKonten_Search_Full_V3Api(
        vSupplierSearchDataObj
      );

      if (vSupplierSearch?.status === 200) {
        const rows = vSupplierSearch?.data?.ResultSet ?? [];
        if (rows.length > 0) {
          const vSupplier = rows[0];

          let vDefaultTaxType = "OTTRN001";
          let iDefaultTaxType = await GetTransTaxType(
            vRdxWmsHead.A_Loc,
            vSupplier?.AcCd
          );
          if (Object.keys(iDefaultTaxType[0]).length != 0) {
            vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
          }
          //if inter.comp then tax group should be 0
          if (!!vSupplier) {
            if (iDefaultTaxType.length > 0) {
              dispatch(
                Set_StockAdjustment_HeadObject_Set({
                  ...vRdxWmsHead,
                  A_Party: vSupplier?.AcCd,
                  A_PartyName: vSupplier?.Name1,
                  A_TaxType: vDefaultTaxType,
                })
              );
              GetDefcustomersetting(vSupplier?.AcCd, vRdxWmsHead.A_Loc);
            } else {
              dispatch(
                Set_StockAdjustment_HeadObject_Set({
                  ...vRdxWmsHead,
                  A_Party: vSupplier?.AcCd,
                  A_PartyName: vSupplier?.Name1,
                })
              );
            }

            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          } else {
            GCToggleSearch_Customer_SearchModalKey(e);
          }
          if (vRdxWmsHead.A_Party != "") {
            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          }
        } else {
          GCToggleSearch_Customer_SearchModalKey(e);
        }
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_StockAdjustment_HeadObject_Set({
          ...vRdxWmsHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          // let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const [GCToggleSearch_Customer_Toggle, set_GCToggleSearch_Customer_Toggle] =
    useState(false);
  const [GCToggleSearch_Customer_Obj, setGCToggleSearch_Customer_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const GCToggleSearch_Customer_Sub_Input = (e) => {
    setGCToggleSearch_Customer_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const GCToggleSearch_Customer_Click = useCallback(() => {
    if (GCToggleSearch_Customer_Toggle) {
      set_GCToggleSearch_Customer_Toggle(false);
      set_GCToggleSearch_Customer_Row_GridData([]);
      // set_GCToggleSearch_Item_Obj({
      //   Type: "Any",
      //   Data: "",
      // });
    } else {
      set_GCToggleSearch_Customer_Toggle(true);
    }
  }, [GCToggleSearch_Customer_Toggle]);

  const GCToggleSearch_Customer_OnKeyUpCustomer = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      Get_GCToggleSearch_Customer_Api(
        GCToggleSearch_Customer_Obj.Data,
        GCToggleSearch_Customer_Obj.Type,
        vRdxWmsHead.A_FromLoc,
        set_GCToggleSearch_Customer_Row_GridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );

          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const GCToggleSearch_Customer_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCToggleSearch_Customer_Obj((obj) => ({
        ...obj,
        Data: vRdxWmsHead.A_PartyName,
      }));
      if (vRdxWmsHead.A_PartyName != "") {
        Get_GCToggleSearch_Customer_Api(
          vRdxWmsHead.A_PartyName,
          "Any",
          vRdxWmsHead.A_FromLoc,
          set_GCToggleSearch_Customer_Row_GridData
        );
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      GCToggleSearch_Customer_Click();
    }
  };
  const GCToggleSearch_Customer_Main_Input = (event) => {
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      event.target.value.length < vRdxWmsHead.A_PartyName.toString().length &&
      vMediaQuery &&
      event.target.name === "A_PartyName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      GCToggleSearch_Customer_Enter_ModalKey(vBackspaceObj);
    }
    dispatch(
      Set_StockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.value,
      })
    );

    set_GCToggleSearch_Customer_ModelObj((obj) => ({
      ...obj,
      AnyData: event.target.value,
    }));
    // ffilterCustomerDropDownSearch(
    //   event.target.value,
    //   sCustFullSearchGridData
    // );
  };
  //GCToggleSearch_Customer end
  // DELETESIHEAD_GETROW

  const fDetail_Grid_DoubleClick = async (item) => {
    console.log("DoubleClick", item);

    let obj = {
      // Merging the existing object
      SrNo: item.row.B_Srno,
      ItemCd: item.row.B_Itmcd,
      Batch: item.row.BatchCrl,
      Serial: item.row.SerialCrl,
      AutoGrn: item.row.AutoGrn || "N",
    };

    setSerialDetalModal(obj);
    setBatchObj((obj) => ({
      ...obj,
      SrNo: item.row.B_Srno,
      ItemCode: item.row.B_Itmcd,
      ItemName: item.row.ItmName,
      Qty: item.row.B_Qty,
      Unit: item.row.B_Unit,
      BaseQty: item.row.B_BaseQty,
    }));
    let { BatchCrl, SerialCrl, BatchQty, Type } = item.row;
    console.log(BatchCrl, SerialCrl, BatchQty);
    if (BatchCrl == "Y" || SerialCrl == "Y") {
      if (Type == "BATCH_ENTRY") {
        setBatchSelectionModalEntry(true);
      } else if (Type == "BATCH_ISSUE") {
        setBatchSelectionModal(true);
      }
    }

    // if (AutoGrn == "Y") {
    //   if (BatchQty == 0) {
    //     fAlertToast("FAILED", "Batch Quantity is zero");
    //   } else {
    //     setRegisterSerialNumberModal(true);
    //   }
    // }
  };
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_Srno, // int
      B_Itmcd: item.row.B_Itmcd,
      B_ItmName: item.row.ItemName,
      B_Qty: item.row.B_Qty, //Decimal
      B_Unit: item.row.B_Unit,
      B_UnitName: item.row.UnitName,
      B_BaseQty: item.row.B_BaseQty, //Decimal
      Reason: item.row.B_Type,
      Auto: item.row.B_Auto,
      B_UnitCost: item.row.B_UCost,
      B_Value: item.row.B_NetAmt,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));
    fCloseViewModal();
  };

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setItemToggleDropdown(false);
      setHeadGridShow(false);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    if (
      vRdxDBKernObj.BATCH_NO_AUTO &&
      vRdxDBKernObj.BATCH_NO_AUTO?.Val === "Y"
    ) {
      //batch field should be disabled
      setbatchFlag(true);
    }
    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setLocationArr,
      setDocLoading,
      setFromLocation,
      setReason,
      setLocationSearchArr,
      setAdjustmentType
    );

    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };
    let vDocLoadingArr = iAttributeResp.Voucher;

    if (vDocLoadingArr.length > 0) {
      icurrentDocLoading = vDocLoadingArr[0];
    }
    let LocFrom = iAttributeResp?.Location;
    let vFromLocation = {
      Name1: "",
      UId: "",
      BatchCtrl: "",
      TRN: "",
    };

    vFromLocation = LocFrom[0];
    // vRdxWmsHead.A_ToLoc

    dispatch(
      Set_StockAdjustment_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,

        A_FromLoc:
          vRdxWmsHead?.A_FromLoc == "" ||
          vRdxWmsHead.A_FromLoc === null ||
          vRdxWmsHead.A_FromLoc === undefined
            ? vFromLocation?.UId
            : vRdxWmsHead.A_FromLoc,
        A_FromLocBatch:
          vRdxWmsHead?.A_FromLocBatch == "" ||
          vRdxWmsHead.A_FromLocBatch === null ||
          vRdxWmsHead.A_FromLocBatch === undefined
            ? vFromLocation?.BatchCtrl == "N"
              ? "Batch : No"
              : "Batch : Yes"
            : vRdxWmsHead.A_FromLocBatch,
        A_FromLocBr:
          vRdxWmsHead?.A_FromLocBr == "" ||
          vRdxWmsHead.A_FromLocBr === null ||
          vRdxWmsHead.A_FromLocBr === undefined
            ? vFromLocation?.Br
            : vRdxWmsHead.A_FromLocBr,
        AdjustmentType:
          vRdxWmsHead?.AdjustmentType == "" ||
          vRdxWmsHead.AdjustmentType === null ||
          vRdxWmsHead.AdjustmentType === undefined
            ? iAttributeResp?.AdjustmentType[0]?.UId
            : vRdxWmsHead?.AdjustmentType,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      setDetailGridData,
      setFooterObj,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp,
      sRoundingVal
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, vRdxGRNtax1, vRdxGRNtax2]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("WmsStockAdjustmentContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
    if (e.which == 27 || e.key === "Escape") {
      set_GCToggleSearch_Customer_Toggle(false);
    }
  }, []);
  useEffect(() => {
    const handleClick = (event) => {
      if (GCToggleSearch_Customer_Toggle) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          set_GCToggleSearch_Customer_Toggle(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [GCToggleSearch_Customer_Toggle]);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "INV10";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  const FocusOnLoad = useRef(null);
  useEffect(() => {
    // FocusOnLoad.current?.focus();
  }, []);
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "NetAmt", headerName: "NetAmt", width: 90 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_TransSrNo", headerName: "A_TransSrNo", width: 90, hide: true },
  ]);
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ]);

  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    {
      field: "id",
      headerName: "ID",
      hide: true,
      width: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "B_Srno",
      headerName: "Sr.No",
      hide: false,
      width: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "B_TypeName",
      headerName: "Reason",
      hide: false,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "B_Itmcd",
      headerName: "Item.Code",
      hide: false,
      width: 90,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "ItemName",
      headerName: "Item.Name",
      hide: false,
      width: 320,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "B_Qty",
      headerName: "Qty",
      hide: false,
      width: 100,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "B_Unit",
      headerName: "Unit",
      hide: true,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "UnitName",
      headerName: "Unit",
      hide: false,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "B_UCost",
      headerName: "Cost",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "B_NetAmt",
      headerName: "Net.Amount",
      hide: false,
      width: 120,
      align: "left",
      headerAlign: "left",
    },
  ]);
  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "STOCK_TRANSFER_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_FromLoc === null ||
      vRdxWmsHead.A_FromLoc === undefined ||
      vRdxWmsHead.A_FromLoc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_FromLoc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_FromLoc,
    vRdxWmsHead.A_DocStat,
  ]);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={vRdxWmsHead.A_DocStat != "ENTER" ? true : false}
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          vRdxWmsHead.A_DocStat == "ENTER" || vRdxWmsHead.A_DocStat == "DRAFT"
            ? sObjRights.RApprove == "N"
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-outbound-grv">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat != "ENTER" ? true : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat == "ENTER" ||
                        vRdxWmsHead.A_DocStat == "DRAFT"
                          ? sObjRights.RApprove == "N"
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="PrintId"
                      onClick={(e) => {
                        fPrint("INV11");
                      }}
                    >
                      Stock Adjustment
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="IdAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>

                {/* <Grid item xs={1} sm={1} md={1} lg={1}>
                <CmpButton
                  xbtnName="Document"
                  xOnClick={fDocument}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<ArticleRoundedIcon />}
                />
              </Grid> */}
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className="wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      //grid saleshistory
                      fAdjustmentType={(e) => {
                        dispatch(
                          Set_StockAdjustment_HeadObject_Set({
                            ...vRdxWmsHead,
                            AdjustmentType: e.target.value,
                          })
                        );
                      }}
                      headGridShow={headGridShow}
                      sHeadGridColumn={sHeadGridColumn}
                      sHeadGridRow={sHeadGridRow}
                      vMediaQuery={vMediaQuery}
                      xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                      sBufferItmCd={sBufferObj.B_Itmcd !== ""}
                      xErrorMsg={sErrorMsg}
                      sFromLocation={sFromLocation}
                      xKey={fKeyStockAdjustment}
                      vRdxWmsHead={vRdxWmsHead}
                      sArr={sArr}
                      fonSelectedGrnType={fGrnType}
                      sDocLoadingGrnType={sDocLoading}
                      sAdjustmentType={sAdjustmentType}
                      fGrnDate={fGrnDate}
                      fInvDate={fInvDate}
                      fFromLocation={fFromLocation}
                      xFocusInput={fFocusInput}
                      inputFocus={FocusOnLoad}
                      dispatch={dispatch}
                      fonChangeDo={(e) => {
                        dispatch(
                          Set_StockAdjustment_HeadObject_Set({
                            ...vRdxWmsHead,
                            A_Do: e.target.checked ? "Y" : "N",
                          })
                        );
                      }}
                      // Customer serarch
                      xonChangeInputCustomer={
                        GCToggleSearch_Customer_Main_Input
                      }
                      xhandleClick={GCToggleSearch_Customer_Enter_ModalKey}
                      xrowDropdownSearch={GCToggleSearch_Customer_Row_GridData}
                      xcolumnsDropdownSearch={columnsCustomerDropdownSearch}
                      xOnCellKeyDown={GCToggleSearch_Customer_RowCellClick}
                      xOnRowClick={GCToggleSearch_Customer_RowClick}
                      xToggleDropdown={GCToggleSearch_Customer_Toggle}
                      xData={["Any", "Code", "Name"]}
                      xOnChange={GCToggleSearch_Customer_Sub_Input}
                      xDropdownObj={GCToggleSearch_Customer_Obj}
                      xOnKeyUp={GCToggleSearch_Customer_OnKeyUpCustomer}
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        onchangeUcost={(e) => {
                          fCalUCostAndValue(
                            sBufferObj.B_Qty,
                            e.target.value,
                            setBufferObj
                          );
                          setBufferObj((obj) => ({
                            ...obj,
                            B_UnitCost: e.target.value,
                            B_Value: (
                              fcovertToNumber(e.target.value) *
                              fcovertToNumber(sBufferObj.B_Qty)
                            ).toFixed(roundingDigit),
                          }));
                        }}
                        fLocationwiseStock={(e) => {
                          setLocationwiseStockModal(true);
                        }}
                        sCurrentStock={sCurrentStock}
                        fReason={(event) => {
                          setBufferObj((obj) => ({
                            ...obj,
                            Reason: event.target.value,
                          }));
                        }}
                        fAuto={async (e) => {
                          setBufferObj((obj) => ({
                            ...obj,
                            Auto: e.target.checked ? "Y" : "N",
                          }));

                          if (e.target.checked) {
                            let currentUnitRateArr = await GetUnitRateArr(
                              sBufferObj.B_Itmcd,
                              sBufferObj.B_Unit,
                              vRdxWmsHead?.A_FromLoc,
                              "" // vRdxWmsHead?.A_RefDocTyp,
                            );

                            if (currentUnitRateArr.length > 0) {
                              fCalUCostAndValue(
                                sBufferObj.B_Qty,
                                currentUnitRateArr[0].CostPr,
                                setBufferObj
                              );
                            } else {
                              fCalUCostAndValue(
                                sBufferObj.B_Qty,
                                0,
                                setBufferObj
                              );
                            }
                          }
                        }}
                        sReason={sReason}
                        setBufferObj={setBufferObj}
                        sTransItemStockObj={sTransItemStockObj}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                        xContent_Focus={fContent_Focus}
                        xContent_Blur={fContent_Blur}
                        xErrorMsgDetail={sErrorMsgDetail}
                        vRdxWmsHead={vRdxWmsHead}
                        xKey={fKeyStockAdjustmentContent}
                        xFocusInput={fFocusInput}
                        xBufferObj={sBufferObj}
                        sUnit={sUnit}
                        fUnit={fUnit}
                        fQty_Save_onKeyUp={fQty_Save_onKeyUp}
                        fOpenContentItemSearchModalKey={fItemSearchKey}
                        fQty={fQty}
                        //GC toggle
                        fItemName={fItemName} //onchange main input
                        xMediaQuery={vMediaQuery} //mobile screen
                        xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                        xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                        xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                        xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                        xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                        xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                        xData={ItemSearchData} // GCToggleSearch-select-tag arr
                        xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                        xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                        xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                      />

                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={(item) => {
                            fDetail_Grid_onRowClick(item);
                          }}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div style={{ height: "30vh", width: "100%" }}>
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fDetail_Grid_onRowClick}
                          hideFooter={sDetailGridData.length < 100}
                          onRowDoubleClick={fDetail_Grid_DoubleClick}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <WmsFooter
                      xErrorMsg={sErrorMsg}
                      xFooterObj={sFooterObj}
                      xKey={fKeyStockAdjustment}
                      vRdxWmsHead={vRdxWmsHead}
                      sArr={sArr}
                      fHeadNarration={fHeadNarration}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Variance"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "65vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsFooter
              xErrorMsg={sErrorMsg}
              xFooterObj={sFooterObj}
              xKey={fKeyStockAdjustment}
              vRdxWmsHead={vRdxWmsHead}
              sArr={sArr}
              fHeadNarration={fHeadNarration}
            />
          </div>
        </Box>
      </Modal>

      {/* Search  */}
      <GCStockTransfer
        // xDisableVocDate={false}
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sLocationSearchArr}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Stock Adjustment - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
      />
      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fCloseAuditModal}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={GridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={fonChangeAuditSelect}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
      /> */}
      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}
      />
      <Modal
        open={sDocumentModal}
        onClose={fCloseDocumentModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-popup">on progerss document...</Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
      <POTypeSearchModal
        open={poType && sBufferObj.B_RefDocTyp == ""}
        onClose={() => {
          setPoType(false);
        }}
        defaultValue={sBufferObj.B_RefDocTypName}
        handleRowClick={(e) => {
          setBufferObj((obj) => ({
            ...obj,
            B_RefDocTypName: e.row.Name1,
            B_RefDocTyp: e.row.UID,
          }));
          setPoType(false);
        }}
      />
      <PoNoSearchModal
        open={poNo && sBufferObj.B_RefDocTyp != ""}
        onClose={() => {
          setPoNo(false);
        }}
        defaultValue={sBufferObj.B_RefDocNo}
        handleRowClick={(e) => {
          setBufferObj((obj) => ({
            ...obj,
            B_RefDocNo: e.row.UID,
          }));
          setPoNo(false);
        }}
        B_RefDocTyp={sBufferObj.B_RefDocTyp}
      />
      <ReqDocumentSearchModal
        open={sReqDocumentSearchModal}
        onClose={() => {
          setReqDocumentSearchModal(false);
        }}
        defaultValue={{
          FromLocation: vRdxWmsHead.A_FromLocName,
          ToLocation: vRdxWmsHead.A_ToLocName,
          FromLocationCd: vRdxWmsHead.A_FromLoc,
          ToLocationCd: vRdxWmsHead.A_ToLoc,
        }}
        handleRowClick={() => {}}
      />

      <BatchSelectionModal
        batchFlag={batchFlag}
        setBatchObj={setBatchObj}
        SerialDetalModal={SerialDetalModal}
        closeModal={() => {
          fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
          setBatchSelectionModalEntry(false);
        }}
        vRdxWmsHead={vRdxWmsHead}
        batchSelectionModal={sbatchSelectionModalEntry}
        sBufferObj={sBufferObj}
        sBatchObj={sBatchObj}
      />
      <BatchSelectionModalIssue
        SrNo={SerialDetalModal.SrNo}
        ItemCd={SerialDetalModal.ItemCd}
        title={
          SerialDetalModal.Batch == "Y" ? "Batch Selection" : "Serial Selection"
        }
        SerialDetalModal={SerialDetalModal}
        open={sbatchSelectionModal}
        handleClose={() => {
          setBatchSelectionModal(false);
          fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
        }}
        xDisable={vRdxWmsHead.A_DocStat != "ENTER"}
      />

      <GCLocationWiseStock
        open={sLocationwiseStockModal}
        fCloseSearchModal={() => {
          setLocationwiseStockModal(false);
        }}
        xTitle={"Locationwise - Stock"}
        B_Itmcd={sBufferObj?.B_Itmcd}
        sLocationArr={sLocationArr}
        xLabelItemName={sBufferObj.B_Itmcd + " - " + sBufferObj.B_ItmName}
        // xLabelBranch={sBufferObj?.B_Br + " - " + sBufferObj?.B_BrName}
      />
    </div>
  );
}
